const emojiCode: string = `program eldaRocks💩

main() {
  emojiprint(🔤Elda Rocks🔤)💩
}`;
export default emojiCode;
